import { useQuery } from '@tanstack/react-query';
import { financialApi } from '../api/financialApi';

interface UseResidentFinancialHistoryParams {
  page?: number;
  limit?: number;
  search?: string;
  residentName?: string;
  status?: string;
}

export const useResidentFinancialHistory = (
  params: UseResidentFinancialHistoryParams = {},
  options?: { enabled?: boolean },
) => {
  return useQuery({
    queryKey: ['resident-financial-history', params],
    queryFn: () => financialApi.getResidentFinancialHistory(params),
    placeholderData: (previousData) => previousData,
    enabled: options?.enabled,
  });
};
